import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'

const environment = require('../environments/production')
const db = firebase.database()

const state = {
  tours: {},
  userTourSettings: {},
  currentTour: '',
  step: 0
}

const getters = {
}

const mutations = {
  setCurrentTour: (state, payload) => {
    state.currentTour = payload
  },
  setCurrentTourStep: (state, payload) => {
    state.step = payload
  }
}
const actions = {
  getTours: firebaseAction(context => {
    let ref = db.ref(environment.schema.tourSettings)
    context.bindFirebaseRef('tours', ref)
  }),
  getUsersTourCompleted: firebaseAction(context => {
    let ref = db.ref(environment.schema.tours).child(context.rootState.user.uid)
    context.bindFirebaseRef('userTourSettings', ref)
  }),
  setCurrentTour: (context, payload) => {
    context.commit('setCurrentTour', payload)
  },
  setCurrentTourStep: (context, payload) => {
    context.commit('setCurrentTourStep', payload)
  },
  setUserTourDisableAll: (context, payload) => {
    return context.dispatch('setUserTourSettings', { disableAll: true })
  },
  setUserTourSetComplete: (context, payload) => {
    const update = {
      [context.state.currentTour]: {
        step: context.state.step,
        ended: (context.state.step === context.state.tours[context.state.currentTour].steps.length)
      }
    }
    return context.dispatch('setUserTourSettings', update)
  },
  setUserTourSettings: (context, payload) => {
    return db.ref(environment.schema.tours).child(context.rootState.user.uid).update(payload)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/tours.js